import { pendingUsersApi } from '../api/pending-users';
import { actionWrapper } from './actionWrapper';

export const SET_PENDING_USERS = 'SET_PENDING_USERS';

export const getPendingUsers = () => actionWrapper(async () => {
  const pendingUsersData = await pendingUsersApi.getPendingUsers();

  return {
    type: SET_PENDING_USERS,
    payload: pendingUsersData,
  };
});
